export enum ContentTableType {
  MyContent = 0,
  TeamContent = 1,
  AllContent = 2,
  ColumnistContent = 3,
  SubEditorContent = 4,
}
